/** TODO temporary. will be refactored */

import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { IOption } from '@cmps/ng-select';

import {
    Column,
    Context,
    DivRendererOptions,
    ExperimentalNgGridComponent,
    GridContent,
    Row,
    SelectTemplateFn,
    Sort,
    SortOrder,
} from './experimental.grid';
import { ParameterFormValue } from './search-user.form';
import {
    ColumnID,
    InputType,
    ParameterTypeConfig,
    ParameterTypeConfigItem,
    StatusType,
    UserSearchResult,
} from './search-user.model';
import { TranslationKeyMap } from './user.i18n';

@Component({
    selector: '[cmpsSearchUser]',
    templateUrl: './search-user.component.html',
})
export class SearchUserComponent implements OnChanges, OnInit {
    @ViewChild('teamGrid')
    private readonly _teamGrid: ExperimentalNgGridComponent;

    @ViewChild('favoritesGrid')
    private readonly _favoritesGrid: ExperimentalNgGridComponent;

    @ViewChild('searchGrid')
    private readonly _searchGrid: ExperimentalNgGridComponent;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _StatusType = StatusType;
    /** @private */ _InputType = InputType;
    /** @private */ _ColumnID = ColumnID;
    /** @private */ _SortOrder = SortOrder;

    @Input() pendingInit: boolean;
    @Input() pendingSearch: boolean;
    @Input() pendingSelectUser: boolean;

    @Input() teamColumns: Column[];
    @Input() teamRows: Row[];
    @Input() teamSortDefs: Sort[];
    @Input() teamGridNeedsLayout: number;

    @Input() favoritesColumns: Column[];
    @Input() favoritesRows: Row[];
    @Input() favoritesSortDefs: Sort[];
    @Input() favoritesGridNeedsLayout: number;

    @Input() parameterLookupOpts: { [key: string]: IOption[] }; // ParameterType
    @Input() didInitialSearch: boolean;
    @Input() searchFailed: boolean;
    @Input() searchExceedsMaxCount: boolean;

    @Input() searchColumns: Column[];
    @Input() searchRows: Row[];
    @Input() searchSortDefs: Sort[];
    @Input() searchGridNeedsLayout: number;

    @Input() selectedUser: UserSearchResult;
    @Input() selectedUserManager: UserSearchResult;

    @Input() hasSelfButton: boolean;
    @Input() statusOpts: IOption[];
    @Input() parameterOpts: IOption[];
    @Input() form: FormGroup;
    @Output() addParameter: EventEmitter<void>;
    @Output() removeParameter: EventEmitter<number>;
    @Output() searchClick: EventEmitter<void>;
    @Output() userClick: EventEmitter<number>;
    @Output() toggleFavorite: EventEmitter<UserSearchResult>;
    @Output() resetClick: EventEmitter<void>;
    @Output() searchGridSortChange: EventEmitter<Column>;
    @Output() selfClick: EventEmitter<void>;
    @Output() selectClick: EventEmitter<void>;

    /** @private */ _teamGridRenderOpts: DivRendererOptions;
    /** @private */ _favoritesGridRenderOpts: DivRendererOptions;
    /** @private */ _searchGridRenderOpts: DivRendererOptions;

    /** @private */ _gridSelectTpl: SelectTemplateFn = (
        context: Context,
        contents: QueryList<GridContent>,
    ) => {
        return typeof context.ctx === 'string'
            ? contents.find((e) => e.type === context.t && e.id === 'header')
            : contents.find((e) => e.type === context.t);
    };

    constructor(
        private readonly _ngZone: NgZone,
        private readonly _changeDetectorRef: ChangeDetectorRef,
    ) {
        this.addParameter = new EventEmitter();
        this.removeParameter = new EventEmitter();
        this.searchClick = new EventEmitter();
        this.userClick = new EventEmitter();
        this.toggleFavorite = new EventEmitter();
        this.resetClick = new EventEmitter();
        this.searchGridSortChange = new EventEmitter();
        this.selfClick = new EventEmitter();
        this.selectClick = new EventEmitter();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('teamColumns')) {
            this._teamGridRenderOpts = {
                ...this._teamGridRenderOpts,
                columns: this.teamColumns,
            };
        } else {
            // if columns is present an inflate will occur later
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('teamRows')) {
                this._onTeamGridInflate();
            }
            // ----------
            // no check for teamSortDefs
            // ----------
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('teamGridNeedsLayout')) {
                this._teamGrid.gridNode.detectChanges();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._teamGrid.renderer.layout();
            }
        }

        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('favoritesColumns')) {
            this._favoritesGridRenderOpts = {
                ...this._favoritesGridRenderOpts,
                columns: this.favoritesColumns,
            };
        } else {
            // if columns is present an inflate will occur later
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('favoritesRows')) {
                this._onFavoritesGridInflate();
            }
            // ----------
            // no check for favoritesSortDefs
            // ----------
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('favoritesGridNeedsLayout')) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._favoritesGrid.renderer.layout();
            }
        }

        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('searchColumns')) {
            this._searchGridRenderOpts = {
                ...this._searchGridRenderOpts,
                columns: this.searchColumns,
            };
        } else {
            // if columns is present an inflate will occur later
            // eslint-disable-next-line no-prototype-builtins
            if (
                // eslint-disable-next-line no-prototype-builtins
                !changes.hasOwnProperty('searchColumns') &&
                // eslint-disable-next-line no-prototype-builtins
                changes.hasOwnProperty('searchRows')
            ) {
                this._onSearchGridInflate();
            }
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('searchSortDefs')) {
                this._searchGrid.gridNode.sort(this.searchSortDefs);
            }
            // eslint-disable-next-line no-prototype-builtins
            if (changes.hasOwnProperty('searchGridNeedsLayout')) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._searchGrid.renderer.layout();
            }
        }
    }

    ngOnInit(): void {
        this._teamGridRenderOpts = {
            columns: this.teamColumns,
            defaultRenderFn: null,
            height: 200,
        };

        this._favoritesGridRenderOpts = {
            columns: this.favoritesColumns,
            defaultRenderFn: null,
            height: 200,
        };

        this._searchGridRenderOpts = {
            columns: this.searchColumns,
            defaultRenderFn: null,
            height: 200,
        };
    }

    /** @private */ _parameters(): FormArray {
        return !this.form ? null : (this.form.get('parameters') as FormArray);
    }

    /** @private */ _parameterTypeConfig(
        index: number,
    ): ParameterTypeConfigItem {
        const value = (this.form.get('parameters') as FormArray).at(index)
            .value as ParameterFormValue;
        return ParameterTypeConfig[value.parameterType];
    }

    /** @private */ _onAddParameterClick(): void {
        this.addParameter.emit();
    }

    /** @private */ _onRemoveParameterClick(index: number): void {
        this.removeParameter.emit(index);
    }

    /** @private */ _onSearchClick($event: MouseEvent | KeyboardEvent): void {
        if (
            $event instanceof KeyboardEvent &&
            ($event.target as HTMLInputElement).type.toLowerCase() !== 'text'
        ) {
            return;
        }
        this.searchClick.emit();
    }

    /** @private */ _onUserClick(userId: number): void {
        this._ngZone.run(() => {
            this.userClick.emit(userId);
        });
    }

    /** @private */ _onToggleFavoriteClick($event: UserSearchResult): void {
        this._ngZone.run(() => {
            this.toggleFavorite.emit($event);
        });
    }

    /** @private */ _onClearClick(): void {
        this.resetClick.emit();
    }

    /** @private */ _onSortClick(column: Column): void {
        this._ngZone.run(() => {
            this.searchGridSortChange.emit(column);
        });
    }

    /** @private */ _onTeamGridInflate(): void {
        this._changeDetectorRef.detectChanges(); // best effort to make sure _teamGrid is set
        if (!this._teamGrid) {
            return;
        }
        this._teamGrid.gridNode.setChildren(this.teamRows || []);
        this._teamGrid.gridNode.sort(this.teamSortDefs);
    }

    /** @private */ _onFavoritesGridInflate(): void {
        this._changeDetectorRef.detectChanges(); // best effort to make sure _favoritesGrid is set
        if (!this._favoritesGrid) {
            return;
        }
        this._favoritesGrid.gridNode.setChildren(this.favoritesRows || []);
        this._favoritesGrid.gridNode.sort(this.favoritesSortDefs);
    }

    /** @private */ _onSearchGridInflate(): void {
        this._changeDetectorRef.detectChanges(); // best effort to make sure _searchGrid is set
        if (!this._searchGrid) {
            return;
        }
        this._searchGrid.gridNode.setChildren(this.searchRows || []);
        this._searchGrid.gridNode.sort(this.searchSortDefs);
    }

    /** @private */ _onSelfClick(): void {
        this._ngZone.run(() => {
            this.selfClick.emit();
        });
    }

    /** @private */ _onSelectClick(): void {
        this.selectClick.emit();
    }
}
